/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
import * as Types from "../../../../../__graphql__/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetHubStockChangeLogsInput = {
  sku: string;
};

export type GetProductStockQueryVariables = Exact<{
  sku: string | number;
  isAlwaysInbound?: boolean | null | undefined;
  withPrice?: boolean | null | undefined;
}>;

export type GetProductStockQuery = {
  getProduct: {
    numberOfShelfFacings: number | null;
    numberOfShelfStackings: number | null;
    isShelvedInHandlingUnits: boolean | null;
    price?: number | null;
    inventoryEntry: { stock: { shelf: number } | null };
  };
};

export type GetHubStockChangeLogsQueryVariables = Exact<{
  input: Types.GetHubStockChangeLogsInput;
}>;

export type GetHubStockChangeLogsQuery = {
  getHubStockChangeLogs: {
    stockChangeLogs: Array<{
      reason: string;
      actor: string;
      quantity: number;
      triggeredAt: string;
    }>;
  };
};

export const GetProductStockDocument = gql`
  query getProductStock($sku: ID!, $isAlwaysInbound: Boolean, $withPrice: Boolean = false) {
    getProduct(input: { sku: $sku }, isAlwaysInbound: $isAlwaysInbound) {
      numberOfShelfFacings
      numberOfShelfStackings
      isShelvedInHandlingUnits
      inventoryEntry {
        stock {
          shelf
        }
      }
      price @include(if: $withPrice)
    }
  }
`;

/**
 * __useGetProductStockQuery__
 *
 * To run a query within a React component, call `useGetProductStockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductStockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductStockQuery({
 *   variables: {
 *      sku: // value for 'sku'
 *      isAlwaysInbound: // value for 'isAlwaysInbound'
 *      withPrice: // value for 'withPrice'
 *   },
 * });
 */
export function useGetProductStockQuery(
  baseOptions: Apollo.QueryHookOptions<GetProductStockQuery, GetProductStockQueryVariables> &
    ({ variables: GetProductStockQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetProductStockQuery, GetProductStockQueryVariables>(
    GetProductStockDocument,
    options,
  );
}
export function useGetProductStockLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetProductStockQuery, GetProductStockQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetProductStockQuery, GetProductStockQueryVariables>(
    GetProductStockDocument,
    options,
  );
}
// @ts-ignore
export function useGetProductStockSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetProductStockQuery,
    GetProductStockQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetProductStockQuery, GetProductStockQueryVariables>;
export function useGetProductStockSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetProductStockQuery, GetProductStockQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetProductStockQuery | undefined, GetProductStockQueryVariables>;
export function useGetProductStockSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetProductStockQuery, GetProductStockQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetProductStockQuery, GetProductStockQueryVariables>(
    GetProductStockDocument,
    options,
  );
}
export type GetProductStockQueryHookResult = ReturnType<typeof useGetProductStockQuery>;
export type GetProductStockLazyQueryHookResult = ReturnType<typeof useGetProductStockLazyQuery>;
export type GetProductStockSuspenseQueryHookResult = ReturnType<
  typeof useGetProductStockSuspenseQuery
>;
export type GetProductStockQueryResult = Apollo.QueryResult<
  GetProductStockQuery,
  GetProductStockQueryVariables
>;
export const GetHubStockChangeLogsDocument = gql`
  query GetHubStockChangeLogs($input: GetHubStockChangeLogsInput!) {
    getHubStockChangeLogs(input: $input) {
      stockChangeLogs {
        reason
        actor
        quantity
        triggeredAt
      }
    }
  }
`;

/**
 * __useGetHubStockChangeLogsQuery__
 *
 * To run a query within a React component, call `useGetHubStockChangeLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHubStockChangeLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHubStockChangeLogsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetHubStockChangeLogsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetHubStockChangeLogsQuery,
    GetHubStockChangeLogsQueryVariables
  > &
    ({ variables: GetHubStockChangeLogsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetHubStockChangeLogsQuery, GetHubStockChangeLogsQueryVariables>(
    GetHubStockChangeLogsDocument,
    options,
  );
}
export function useGetHubStockChangeLogsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetHubStockChangeLogsQuery,
    GetHubStockChangeLogsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetHubStockChangeLogsQuery, GetHubStockChangeLogsQueryVariables>(
    GetHubStockChangeLogsDocument,
    options,
  );
}
// @ts-ignore
export function useGetHubStockChangeLogsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetHubStockChangeLogsQuery,
    GetHubStockChangeLogsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetHubStockChangeLogsQuery, GetHubStockChangeLogsQueryVariables>;
export function useGetHubStockChangeLogsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetHubStockChangeLogsQuery,
        GetHubStockChangeLogsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetHubStockChangeLogsQuery | undefined,
  GetHubStockChangeLogsQueryVariables
>;
export function useGetHubStockChangeLogsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetHubStockChangeLogsQuery,
        GetHubStockChangeLogsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetHubStockChangeLogsQuery, GetHubStockChangeLogsQueryVariables>(
    GetHubStockChangeLogsDocument,
    options,
  );
}
export type GetHubStockChangeLogsQueryHookResult = ReturnType<typeof useGetHubStockChangeLogsQuery>;
export type GetHubStockChangeLogsLazyQueryHookResult = ReturnType<
  typeof useGetHubStockChangeLogsLazyQuery
>;
export type GetHubStockChangeLogsSuspenseQueryHookResult = ReturnType<
  typeof useGetHubStockChangeLogsSuspenseQuery
>;
export type GetHubStockChangeLogsQueryResult = Apollo.QueryResult<
  GetHubStockChangeLogsQuery,
  GetHubStockChangeLogsQueryVariables
>;
